import {
  afiliatedServices,
  particularServices,
  lastServiceEnum,
} from "./options";

export const towServiceCodes = [
  afiliatedServices.crane,
  afiliatedServices.craneExtended,
  particularServices.crane,
];

/**
 * Indica si el código de producto corresponde a un servicio de grúa.
 *
 * @param {string} code Código del producto seleccionado.
 * @returns {boolean}
 */
export const isTowServiceCode = (code) => towServiceCodes.includes(code);

/**
 * Indica si el caso ya tiene un servicio de grúa creado.
 *
 * @param {object} _case Caso con su lista de servicios.
 * @returns {boolean}
 */
export const caseHasTowService = (_case) =>
  Boolean(_case?.services?.some((s) => s?.type === lastServiceEnum.CRANE));

/**
 * Un servicio de grúa no se edita con PUT /services/:id/updateAv (solo aplica a AV).
 *
 * @param {object} _case Caso que se está editando.
 * @param {string} selectedCode Código del producto seleccionado.
 * @returns {boolean} true si se puede usar updateAv.
 */
export const canEditAsAVService = (_case, selectedCode) =>
  !isTowServiceCode(selectedCode) && !caseHasTowService(_case);

// El backend usa useExtendedTow para decidir entre los productos GRUA y GRUA_EXT
// de la membresia. Si se omite asume false y crea el servicio como GRUA.
export const isExtendedTowProduct = (product) =>
  product?.code === afiliatedServices?.craneExtended;

// Arma el body de POST /services/createTow a partir del producto seleccionado
// del catalogo (/productsCatalog/affiliated)
export const buildCreateTowPayload = (selectedProduct, fields = {}) => {
  const data = { ...fields };
  if (isExtendedTowProduct(selectedProduct)) {
    data.useExtendedTow = true;
  }
  return data;
};
